import { z } from 'zod';

const imageDto = z.object({
  url: z.string().url(),
  alt: z.string().default(''),
});

const elementPositionDto = z.object({ x: z.number(), y: z.number(), width: z.number() });
const deviceLayoutDto = z.object({
  title: elementPositionDto,
  description: elementPositionDto,
  button: elementPositionDto,
});
const heroLayoutDto = z.object({
  desktop: deviceLayoutDto,
  tablet: deviceLayoutDto,
  mobile: deviceLayoutDto,
});

export const sliderDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  title: z.string().default(''),
  subtitle: z.string().default(''),
  description: z.string().default(''),
  cta_label: z.string().default(''),
  background_color: z.string().nullable().default(null),
  display_mode: z.enum(['image', 'composed']).nullable().default(null),
  copy_x_desktop: z.number().default(28),
  copy_y_desktop: z.number().default(50),
  copy_x_mobile: z.number().default(50),
  copy_y_mobile: z.number().default(50),
  image_scale_desktop: z.number().default(100),
  hero_layout: heroLayoutDto.nullable().default(null),
  cta_url: z.string().nullable().default(null),
  youtube_url: z.string().nullable().default(null),
  image: imageDto.nullable().default(null),
  mobile_image: imageDto.nullable().default(null),
});

export const sliderListDto = z.object({ data: z.array(sliderDto) });

export type SliderDto = z.infer<typeof sliderDto>;
